// @ts-nocheck

// Use to place elements on canvas relatively to a new width, 400 is reference value we use to place elements on canvas
export default (value, width) => Math.ceil((value / 400) * width);
